{
  "monthly_label": "Monthly",
  "yearly_label": "Yearly",
  "yearly_savings": "(Save {{amount}})",
  "no_offers": "No subscription options available.",
  "purchase_options_unavailable": "Subscription options are temporarily unavailable.",
  "try_again": "Try Again",
  "loading": "Loading...",
  "voucher_button": "Voucher? Click here.",
  "test_store_badge": "Test Store - simulated purchases",
  "purchase_failed": "An error occurred during purchase.",
  "period_year": "year",
  "period_month": "month",
  "no_active_subscription_title": "No Active Subscription",
  "no_active_subscription_message": "Subscribe to unlock all exercises and features.",
  "subscribe_cta": "View Plans"
}
